const getUsername = ({userId, users, notFoundLabel = '-'}) =>
  [...users].find(({id}) => id === userId)?.username || notFoundLabel;

export default getUsername;
